export default __webpack_public_path__ + "static/media/student.dfdf5b11.svg";